const searchParam = new URLSearchParams(window.location.search);

export default function getZdd() {
  return searchParam.get('zdd') || process.env.REACT_APP_DEFAULT_ZDD;
}
